module.exports = __webpack_public_path__ + "static/media/avocado_toast.7fc44c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/avocado_toast.jpg
// module id = 340
// module chunks = 0